// extracted by mini-css-extract-plugin
export var success = "textpage-module--success--Y-SAT";
export var textPage = "textpage-module--text-page--JQTQ4";